// extracted by mini-css-extract-plugin
export default {"txt":"styles_txt__-IJCm","nextBtn":"styles_nextBtn__Bxmn+"};